import {I18n} from '@aws-amplify/core';
import {
    Anchor,
    Group
} from '@mantine/core';

export const UseAnotherAccount = ({onClick}: { onClick: () => void }) => {
    return (
        <Group justify="center">
            <Anchor component="button" type="button" onClick={onClick}>
                {I18n.get('Use another account')}
            </Anchor>
        </Group>
    );
};
